import script from "./Order.vue?vue&type=script&lang=ts&setup=true"
export * from "./Order.vue?vue&type=script&lang=ts&setup=true"

import "./Order.vue?vue&type=style&index=0&id=98d3b8f8&lang=less&scoped=true"

import exportComponent from "D:\\鹿小岚\\crm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-98d3b8f8"]])

export default __exports__